module.exports = __webpack_public_path__ + "img/mine-back.3fce9ddb.png";